import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { VisualizationDashboardGitService } from './visualization-dashboard-git.service';

@Injectable({ providedIn: 'root' })
export class VisualizationDashboardGitFactoryService extends AbstractGitFactoryService<VisualizationDashboardGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: VisualizationDashboardGitService,
    });
  }
}
